import React, { Suspense, useEffect, useState } from 'react';

import {
  BaseModalContainer,
  CelebrationIcon,
  CloseIcon,
  LazyConfettiComponent
} from '@nw/shared/ui';

import './index.css';
import {
  CelebrationIconWrapper,
  CloseIconWrapper,
  Description,
  Heading,
  ModalContent,
} from './styledComponents';


interface CongratulationsModalProps {
  isModalOpen: boolean;
  onClose?: () => void;
}

export const CongratulationsModal = ({
  isModalOpen,
  onClose
}: CongratulationsModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(isModalOpen);
  }, [isModalOpen]);

  const handleClose = () => {
    setIsOpen(false);
    onClose?.();
  };

  const renderModalContent = () => {
    return (
      <>

          <Suspense fallback={null}>
            <LazyConfettiComponent />
          </Suspense>
          
        <ModalContent>
          <CloseIconWrapper
            onClick={handleClose}
            id="payment-congratulations-modal-close"
          >
            <CloseIcon height={18} width={18} stroke={'#334155'} />
          </CloseIconWrapper>
          <CelebrationIconWrapper>
            <CelebrationIcon width={64} height={64} />
          </CelebrationIconWrapper>
          <Heading>Offer Unlocked!</Heading>
          <Description>
            You've successfully availed a discount on your application.
          </Description>
        </ModalContent>

      </>
    );
  };

  return (
    <BaseModalContainer
      isModalOpen={isOpen}
      onModalClose={handleClose}
      className="CongratulationsModal"
      overlayClassName="CongratulationsModal-modal-overlay"
      hideCloseIcon={true}
    >
      {renderModalContent()}
    </BaseModalContainer>
  );
};
